import { MediaInner } from '@commerce-product-webcomponents/sdk';
import { Logger } from '@nextgen-web-framework/core';
import { ComponentType } from '../../registries/types/propTypes';
import { CMSDataType } from '../../../utils/common';
import { CustomerLeadCardProps } from '../../../../ui/components/CustomerLeadCard/types/propTypes';
import { ResourceType } from '../../../../ui/components/ContentCard/types/propsTypes';
import { PromotionOverviewProps, ValidityList } from '../../../components/PromotionOverview/types/propsTypes';

export const transformGalleryList = (contentDetailGallery: CMSDataType) => {
  const galleryList: MediaInner[] = [];
  contentDetailGallery?.media_gallery.forEach((item: CMSDataType) => {
    if (item?.media_type === ResourceType.image && item.image?.length > 0) {
      for (const img of item.image) {
        const imageData = {
          altText: img?.alt_text,
          publicUrl: img?.image.url,
          format: '',
          mediaId: '',
        };
        galleryList.push({
          type: ResourceType.image,
          main: imageData,
          thumbnail: imageData,
        });
      }
    } else if (item?.media_type === ResourceType.video && item.video?.brightcove?.length > 0) {
      for (const video of item.video.brightcove) {
        const format = video.original_filename.split('.').pop();
        const videoData = {
          format: format,
          mediaId: video.id,
          accountId: video.account_id,
          publicUrl: '',
        };
        galleryList.push({
          type: ResourceType.video,
          thumbnail: {
            altText: video.name,
            publicUrl: video.images.thumbnail.src,
            format: video.images.thumbnail.src.split('.').pop(),
            mediaId: '',
          },
          mobile: videoData,
          tablet: videoData,
          desktop: videoData,
        });
      }
    }
  });
  return galleryList;
};
const transformPromotionOverview = (data: CMSDataType): PromotionOverviewProps => {
  const logger = Logger.getInstance({
    component: 'promotion-overview-transformer.ts',
    product: 'commerce-webcomponent',
  });
  try {
    const contentDetailGallery = Array.isArray(data?.promotion_overview)
      ? data?.promotion_overview[0]
      : data?.promotion_overview;
    const validityItems: CustomerLeadCardProps[] = contentDetailGallery?.validity?.items.map((item: CMSDataType) => ({
      tagBackgroundColor: item.tag_background.color,
      tagNameColor: item.tag_color.color,
      tagName: item.tag,
      title: item.title,
      description: item.description,
    }));
    const validityList: ValidityList = {
      title: contentDetailGallery?.validity.title as string,
      items: validityItems,
    };
    const descRte = contentDetailGallery?.overview.description_rte;
    return {
      componentType: ComponentType.promotion_overview,
      galleryList: transformGalleryList(contentDetailGallery),
      tag: contentDetailGallery?.overview.tagline,
      title: contentDetailGallery?.overview.title,
      description: descRte || contentDetailGallery?.overview.description,
      sanitize: contentDetailGallery?.overview.sanitize ?? false,
      sanitizationConfig: contentDetailGallery?.overview.sanitizationConfig ?? {},
      validityList,
    };
  } catch (error) {
    logger.error('Error while setting up the promotion ', error);
    return {
      componentType: ComponentType.error_page,
      galleryList: [],
      tag: '',
    };
  }
};

export default transformPromotionOverview;
